import { graphql } from "@/api/graphql/types/gql.ts";

export const GetActionsByAccountQuery = graphql(`
  query GetActionsByAccountQuery($request: AccountsMsSearchAuditLogsRequest) {
    AccountsMsSearchAuditLogs(request: $request) {
      data {
        id
        action
        AgentIdData {
          firstName
          lastName
          id
          AccessIdData {
            igg
          }
        }
        UserIdData {
          firstName
          lastName
        }
        whenTs
      }
      pagination {
        size
        page
        total
      }
    }
  }
`);
